__turbopack_context__.v({
  "card": "MiniProductCard-module-scss-module__I6FtWG__card",
  "cartAction": "MiniProductCard-module-scss-module__I6FtWG__cartAction",
  "image": "MiniProductCard-module-scss-module__I6FtWG__image",
  "imageWrapper": "MiniProductCard-module-scss-module__I6FtWG__imageWrapper",
  "info": "MiniProductCard-module-scss-module__I6FtWG__info",
  "link": "MiniProductCard-module-scss-module__I6FtWG__link",
  "name": "MiniProductCard-module-scss-module__I6FtWG__name",
  "originalPrice": "MiniProductCard-module-scss-module__I6FtWG__originalPrice",
  "price": "MiniProductCard-module-scss-module__I6FtWG__price",
  "salePrice": "MiniProductCard-module-scss-module__I6FtWG__salePrice",
});
